import { render } from "./SceneManage.vue?vue&type=template&id=7158d3be&scoped=true&ts=true"
import script from "./SceneManage.vue?vue&type=script&lang=ts"
export * from "./SceneManage.vue?vue&type=script&lang=ts"

import "./SceneManage.vue?vue&type=style&index=0&id=7158d3be&scoped=true&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7158d3be"]])

export default __exports__